import { AutogenLayoutWirecodeLookup } from "./autogen/AutogenLayoutWirecodeLookup";

export class WirecodeLookup extends AutogenLayoutWirecodeLookup {

}
